export default "__VITE_ASSET__Ba8kAj0q__"